import React from "react"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Helmet } from "react-helmet"
import { useGetPagesDataQuery } from "redux/cms/api"
import CmsTab from "../Common/Tab"
function NewsBlogs() {
  const { data, isLoading, isSuccess, refetch } =
    useGetPagesDataQuery("news-blogs")

  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "Business & Services",
      link: "/pages/news-blogs",
    },
    paths: [
      {
        label: "Pages",
        link: "/pages/news-blogs",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>News & Blogs | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <CmsTab
            data={data}
            isLoading={isLoading}
            isSuccess={isSuccess}
            tab={"News & Blogs"}
            refetch={refetch}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default NewsBlogs
